import type { QueueRules } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const QueueRuleItem: RelationFieldProps<QueueRules> = {
  renderItem: (item) => ({
    title: item?.name ?? '',
    descriptionItems: <></>,
  }),
};
